import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { dateFormatPipe } from './date-formatter.pipe';
import { phoneFormatPipe } from './phone-formatter.pipe';
import { phoneFormatInputPipe } from './phone-formatter-input.pipe';
import { timeDifferencePipe } from './time-difference-formatter.pipe';
import { contactViewPipe } from './phone-view.pipe';
import { cardNumberFormatPipe } from './card-number-formatter.pipe';
import { kiloFormatPipe } from './kilo-formatter.pipe';


@NgModule({
    imports: [],
    declarations: [
        dateFormatPipe,
        phoneFormatPipe,
        phoneFormatInputPipe,
        timeDifferencePipe,
        contactViewPipe,
        cardNumberFormatPipe,
        kiloFormatPipe
    ],
    providers: [],
    exports: [
        dateFormatPipe,
        phoneFormatPipe,
        phoneFormatInputPipe,
        timeDifferencePipe,
        contactViewPipe,
        cardNumberFormatPipe,
        kiloFormatPipe
    ]
})

export class PipeModule { }